// extracted by mini-css-extract-plugin
export default {"menuBlock":"sE-z","title":"tE-z","nav":"uE-z","flexCell":"vE-z","facetLink":"wE-z"};